import { pathologiesGrandMotherSlug, pathologiesMotherSlug } from 'templates/Pathologies/utils/slugs';
import { pathologyUrl } from 'utils/pathologyUrlHelper';

export const footerLinks = [
  {
    title: 'Tout sur l\’érection',
    link: '/blog/erection/',
    links: [
      {
        to: '/blog/erection/erection-forte/',
        title: 'Érection',
      },
      {
        to: '/blog/erection/priapisme/',
        title: 'Priapisme',
      },
      {
        to: '/blog/erection/perte-de-sensation-du-penis/',
        title: 'Sensation de fourmillement dans la verge'
      },
      {
        to: '/blog/erection/erection-molle/',
        title: 'Érection faible'
      },
      {
        to: '/blog/erection/problemes-derection-a-50-ans/',
        title: 'Problème d\'érection à 50 ans que faire'
      },
      {
        to: '/blog/erection/problemes-derection-a-60-ans/',
        title: 'Problème d\'érection à 60 ans que faire'
      },
      {
        to: '/blog/erection/medicaments/',
        title: 'Quel est le meilleur médicament contre l\'impuissance',
      },
      {
        to: '/blog/erection/penis-courbe-vers-le-bas/',
        title: 'Penis courbé',
      },
      {
        to: '/blog/erection/maladie-de-lapeyronie/',
        title: 'Maladie de Lapeyronie',
      },
    ],
  },
  {
    title: 'Tout sur l\’éjaculation précoce',
    link: '/blog/ejaculation-precoce/',
    links: [
      {
        to: '/blog/ejaculation-precoce/definition-ejaculateur-precoce/',
        title: 'Éjaculation précoce',
      },
      {
        to: '/blog/ejaculation-precoce/comment-retarder-l-ejaculation/',
        title: 'Retarder \'éjaculation',
      },
      {
        to: '/blog/ejaculation-precoce/medicament-pour-retarder-lejaculation/',
        title: 'Médicament pour retarder l\'éjaculation',
      },
      {
        to: '/blog/ejaculation-precoce/ejaculation-precoce-traitements-remedes-et-solutions/',
        title: 'Éjaculation précoce solution naturelle',
      },
      {
        to: '/blog/ejaculation-precoce/hypersensibilite-du-gland/',
        title: 'Gland sensible',
      },
      {
        to: '/blog/ejaculation-precoce/durer-plus-longtemps-au-lit/',
        title: '3 exercices pour durer au lit',
      },
      {
        to: '/blog/ejaculation-precoce/preservatif-retardant/',
        title: 'Preservatif retardant',
      },
      {
        to: '/blog/ejaculation-precoce/ejaculation-retrograde/',
        title: 'Éjaculation rétrograde',
      },
      {
        to: '/blog/ejaculation-precoce/masturbation-et-ejaculation-precoce/',
        title: 'Masturbation éjaculation',
      },
      {
        to: '/blog/ejaculation-precoce/aspermie/',
        title: 'Aspermie',
      },

    ],
  },
  {
    title: 'Sexualité',
    link: '/blog/sexualite/',
    links: [
      {
        to: '/blog/sexualite/sexologue/',
        title: 'Médecin sexologue',
      },
      {
        to: '/blog/sexualite/taille-penis/',
        title: 'Taille moyenne pénis',
      },
      {
        to: '/blog/sexualite/petit-penis/',
        title: 'Petit pénis',
      },
      {
        to: '/blog/sexualite/agrandir-son-penis/',
        title: 'Agrandir son pénis',
      },
      {
        to: '/blog/sexualite/testosterone/',
        title: 'Testostérone homme',
      },
      {
        to: '/blog/sexualite/libido/',
        title: 'Augmenter sa libido',
      },
      {
        to: '/blog/sexualite/faire-jouir-sans-penetration/',
        title: 'Comment faire jouir une femme',
      },
      {
        to: '/blog/sexualite/kegel-homme/',
        title: 'Exercice de Kegel homme',
      },
      {
        to: '/blog/sexualite/impuissance/',
        title: 'Impuissance masculine',
      },
      {
        to: '/blog/sexualite/panne-sexuelle/',
        title: 'Panne sexuelle',
      },
    ],
  },
  {
    title: 'Sommeil',
    link: '/blog/sommeil/',
    links: [
      {
        to: '/blog/sommeil/apnee-du-sommeil/',
        title: 'Apnée du sommeil',
      },
      {
        to: '/blog/sommeil/symptomes-apnee-du-sommeil/',
        title: "Symptômes apnée du sommeil",
      },
      {
        to: '/blog/sommeil/traitements-apnee-du-sommeil/',
        title: 'Traitements apnée du sommeil',
      },
      {
        to: '/blog/sommeil/paralysie-du-sommeil/',
        title: 'Paralysie du sommeil',
      },
      {
        to: '/blog/sommeil/cycle-de-sommeil/',
        title: 'Cycle de sommeil',
      },
      {
        to: '/blog/sommeil/troubles-du-sommeil/',
        title: 'Troubles du sommeil',
      },
      {
        to: '/blog/sommeil/hormone-du-sommeil/',
        title: 'Hormone du sommeil',
      },
      {
        to: '/blog/sommeil/insomnie/',
        title: 'Insomnie',
      },
      {
        to: '/blog/sommeil/hypnose-sommeil/',
        title: 'Hypnose et sommeil',
      },
      {
        to: '/blog/sommeil/specialistes-du-sommeil/',
        title: 'Spécialistes du sommeil',
      },
    ],
  },
  {
    title: 'Cheveux',
    link: '/blog/cheveux/',
    links: [
      {
        to: '/blog/cheveux/chute-de-cheveux/',
        title: 'Chute de cheveux',
      },
      {
        to: '/blog/cheveux/perte-de-cheveux/',
        title: 'Perte de cheveux',
      },
      {
        to: '/blog/cheveux/minoxidil/',
        title: 'Minoxidil',
      },
      {
        to: '/blog/cheveux/luxeol-pour-cheveux/',
        title: 'Luxéol pour cheveux',
      },
      {
        to: '/blog/cheveux/alopecie/',
        title: 'Alopécie',
      },
      {
        to: '/blog/cheveux/alopecie-androgenetique/',
        title: 'Alopécie androgénétique',
      },
      {
        to: '/blog/cheveux/vitamines-cheveux/',
        title: 'Vitamines cheveux',
      },
      {
        to: '/blog/cheveux/dermite-seborrheique/',
        title: 'Dermite séborrhéique ',
      },
      {
        to: '/blog/cheveux/chute-de-cheveux-traitement-naturel/',
        title: 'Chute de cheveux traitement naturel',
      },
      {
        to: '/blog/cheveux/traitement-repousse-cheveux-efficace/',
        title: 'Traitement repousse cheveux efficace',
      },
    ],
  },
  {
    title: 'Digestion',
    link: '/blog/digestion/',
    links: [
      {
        to: '/blog/digestion/combien-de-temps-pour-digerer/',
        title: 'Combien de temps pour digérer',
      },
      {
        to: '/blog/digestion/medicament-digestion-difficile/',
        title: 'Médicament pour digestion difficile',
      },
      {
        to: '/blog/digestion/calmosine-digestion/',
        title: 'Calmosine digestion',
      },
      {
        to: '/blog/digestion/stomie-digestive/',
        title: 'Stomie digestive',
      },
      {
        to: '/blog/digestion/sucs-digestifs/',
        title: 'Sucs digestifs',
      },
      {
        to: '/blog/digestion/endoscopie-digestive/',
        title: 'Endoscopie digestive',
      },
      {
        to: '/blog/digestion/douleur-estomac/',
        title: 'Douleur à l\'estomac',
      },
      {
        to: '/blog/digestion/enzymes-digestives/',
        title: 'Enzymes digestives',
      },
    ],
  },
  {
    title: 'Médicaments',
    link: '/blog/medicament/',
    links: [
      {
        to: '/blog/medicament/viagra-description/',
        title: 'Viagra',
      },
      {
        to: '/blog/medicament/acheter-viagra/',
        title: 'Acheter du Viagra',
      },
      {
        to: '/blog/medicament/description-sildenafil/',
        title: 'Sildenafil',
      },
      {
        to: '/blog/medicament/acheter-sildenafil/',
        title: 'Acheter du Sildenafil',
      },
      {
        to: '/blog/medicament/description-cialis/',
        title: 'Cialis',
      },
      {
        to: '/blog/medicament/acheter-cialis/',
        title: 'Acheter du Cialis',
      },
      {
        to: '/blog/medicament/description-tadalafil/',
        title: 'Tadalafil',
      },
      {
        to: '/blog/medicament/acheter-tadalafil/',
        title: 'Acheter du Tadalafil',
      },
      {
        to: '/blog/medicament/levitra/',
        title: 'Levitra',
      },
      {
        to: '/blog/medicament/spedra/',
        title: 'Spedra',
      },
      {
        to: '/blog/medicament/priligy/',
        title: 'Priligy',
      },
      {
        to: '/blog/medicament/comparaison-viagra-cialis/',
        title: 'Cialis vs Viagra',
      },
      {
        to: '/blog/medicament/cialis-prix-remboursement/',
        title: 'Cialis prix',
      },
    ],
  },
  {
    title: 'Traitements',
    link: '/blog/traitement/',
    links: [
      {
        to: '/blog/traitement/anneau-penien-cockring/',
        title: 'Anneau pénien',
      },
      {
        to: '/blog/traitement/emla/',
        title: 'Emla',
      },
      {
        to: '/blog/traitement/fortacin/',
        title: 'Fortacin',
      },
      {
        to: '/blog/traitement/pompe-a-penis/',
        title: 'Pompe à pénis',
      },
      {
        to: '/blog/traitement/edex/',
        title: 'Edex',
      },
      {
        to: '/blog/traitement/vitaros/',
        title: 'Vitaros',
      },
      {
        to: '/blog/traitement/viagra-pour-femme/',
        title: 'Viagra femme',
      },
      {
        to: '/blog/traitement/paroxetine-et-ejaculation-precoce/',
        title: 'Paroxétine',
      },
      {
        to: '/blog/traitement/gel-retardant-avis/',
        title: 'Gel retardant',
      },
      {
        to: '/blog/traitement/prothese-penienne/',
        title: 'Prothèse pénienne',
      },

    ],
  },
  {
    title: 'Autres produits',
    link: '/blog/autre-produit/',
    links: [
      {
        to: '/blog/autre-produit/kamagra/',
        title: 'Kamagra',
      },
      {
        to: '/blog/autre-produit/orviax/',
        title: 'Orviax',
      },
      {
        to: '/blog/autre-produit/stud-100/',
        title: 'Stud 100',
      },
      {
        to: '/blog/autre-produit/avis-viasil-produit-miracle-ou-arnaque/',
        title: 'Viasil',
      },
      {
        to: '/blog/autre-produit/member-xxl-avis/',
        title: 'Member xxl',
      },
      {
        to: '/blog/autre-produit/titan-gel/',
        title: 'Titan gel',
      },
      {
        to: '/blog/autre-produit/aphrodisiaques/',
        title: 'Aphrodisiaque naturel',
      },
      {
        to: '/blog/autre-produit/clou-de-girofle-aphrodisiaque/',
        title: 'Les bienfaits du clou de girofle pour l\'homme',
      },
      {
        to: '/blog/autre-produit/viagra-naturel/',
        title: 'Viagra naturel',
      },
      {
        to: '/blog/autre-produit/miel-aphrodisiaque/',
        title: 'Miel aphrodisiaque',
      },

    ],
  },
];


export const endFooterLinks = () => {
  return [
    {
      title: 'Pathologies',
      titleLink: pathologiesGrandMotherSlug(),
      items:
      [
        {
          title: 'Trouble de l\'érection',
          link: pathologyUrl("sante-sexuelle", "problemes-erection"),
        },
        {
          title: 'Retarder l\'éjaculation',
          link: pathologyUrl("sante-sexuelle", "ejaculation-precoce"),
        },
        {
          title: 'Baisse de libido',
          link: pathologyUrl("sante-sexuelle", "baisse-de-libido"),
        },
        {
          title: 'Impuissance masculine',
          link: pathologyUrl("sante-sexuelle", "impuissance"),
        },
        {
          title: 'Perte de poids',
          link: 'https://poids.charles.co/',
        },
        {
          title: 'Chute de cheveux',
          link: pathologyUrl("cheveux", "perte-de-cheveux"),
        },
        // TODO NEXTGEN
        // {
        //   title: 'Troubles digestifs',
        //   link: pathologyUrl("digestion", "troubles-digestifs"),
        // },
      ],
    },
    {
      title: 'À propos',
      items:
      [
        {
          title: 'Comment ça marche',
          link: '/comment-ca-marche/',
        },
        {
          title: 'Approche médicale',
          link: '/approche-medicale/',
        },
        {
          title: 'Annuaire sexologues',
          link: '/sexologue/',
        },
        {
          title: 'Presse',
          link: '/presse/',
        },
        {
          title: 'Études & Sondages',
          link: '/blog/etudes-et-sondages/',
          ref: 'Sondages et études médicales'
        },
      ],
    },
    {
      title: 'Blog',
      items:
      [
        {
          title: 'La sexualité',
          link: '/blog/sexualite/',
        },
        {
          title: 'Les médicaments',
          link: '/blog/medicament/',
        },
        {
          title: 'Les traitements',
          link: '/blog/traitement/',
        },
        {
          title: 'Les pannes d\'érection',
          link: '/blog/erection/',
        },
        {
          title: 'Les problèmes d\'éjaculation précoce',
          link: '/blog/ejaculation-precoce/',
        },
        {
          title: "L'obésité",
          link: '/blog/poids/',
        },
        {
          title: 'La chute de cheveux',
          link: '/blog/cheveux/',
        }
      ],
    },
  ]
}
